<mat-sidenav-container [autosize]="true">
  @if (patient$ | async; as patient) {
  <mat-sidenav
    color="accent"
    mode="side"
    opened
    [ngClass]="{ opened: (opened | async), closed: (opened | async) === false }"
  >
    <div class="sidebar-container">
      <!-- Patient name/id -->
      <div class="nav-header">
        <button
          (click)="navigationService.toggleSidenav()"
          mat-icon-button
          class="nav-button"
          [matTooltip]="(opened | async) ? 'Collapse sidebar' : 'Expand sidebar'"
          matTooltipPosition="right"
        >
          <mat-icon>{{ (opened | async) ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</mat-icon>
        </button>
        @if (opened | async) { @if ((loading | async) === true) {
        <div class="sidebar-content" style="min-width: 300px; margin-top: 20px; padding-right: 60px">
          <div [reactComponent]="LoaderWrapper"></div>
        </div>
        } @if ((loading | async) === false && !patient) {
        <div class="sidebar-content" style="min-width: 300px; margin-top: 20px; padding-right: 60px">
          An error has occurred. Please refresh the browser and try again.
        </div>
        } @if ((loading | async) === false && patient) {
        <div class="sidebar-content" style="margin-top: 10px; padding-left: 0">
          <div
            [reactComponent]="PatientInfoSummaryWrapper"
            [props]="{
                  alertService: this.alertService,
                  patient: patient,
                  patientDisplayAge: displayAge,
                }"
          ></div>
          @if (environment.featuresEnabled.elation && displayElationChartButton) {
          <div
            style="margin-top: 20px"
            [reactComponent]="ElationChartButtonWrapper"
            [props]="{
                    displayPatientElationLink: displayElationChartButton,
                    patientElationLink: elationChartLink,
                  }"
          ></div>
          }
        </div>
        } }
      </div>
      @if ((loading | async) === false && (opened | async)) {
      <div class="sidebar-content sidebar-button-content">
        <!-- Nav buttons -->
        <div fxLayout="{{ (opened | async) ? 'row' : 'column' }}" class="button--container top-border">
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            (click)="navigateToDocumentsTable(patient.id)"
            matTooltip="Documents"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Documents</span>
            <mat-icon>content_copy</mat-icon>
          </button>
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', 'schedule', patient.id]"
            matTooltip="Schedule"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Schedule</span>
            <mat-icon>event</mat-icon>
          </button>
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', 'chat', patient.id]"
            matTooltip="Chat"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <mat-icon
              matBadge="{{ unreadMessageCountFromPatient | async }}"
              matBadgeColor="{{ (unreadMessageCountFromPatient | async) > 0 ? 'warn' : 'accent' }}"
              matBadgeOverlap="true"
              >question_answer</mat-icon
            >
            <span class="cdk-visually-hidden">Chat ({{ unreadMessageCountFromPatient | async }})</span>
          </button>
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', 'invoices', patient.id]"
            matTooltip="Invoices"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Invoices</span>
            <mat-icon>request_quote</mat-icon>
          </button>
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', 'view', patient.id]"
            matTooltip="Account Info"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Account Info</span>
            <mat-icon>account_circle</mat-icon>
          </button>
        </div>
        <div fxLayout="{{ (opened | async) ? 'row' : 'column' }}" class="button--container bottom-border">
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', 'history', patient.id]"
            matTooltip="Medical History"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Medical History</span>
            <mat-icon>article</mat-icon>
          </button>
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', patient.id, 'charts']"
            matTooltip="Charts"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Charts</span>
            <mat-icon>inventory</mat-icon>
          </button>
          <button
            class="nav-button"
            mat-icon-button
            routerLinkActive="active"
            [routerLink]="['/', 'patients', 'vitals', patient.id]"
            matTooltip="Vitals"
            [matTooltipPosition]="(opened | async) ? 'above' : 'right'"
          >
            <span class="cdk-visually-hidden">Vitals</span>
            <mat-icon>assessment</mat-icon>
          </button>
        </div>
      </div>
      <div class="sidebar-content bottom-border" style="margin-bottom: 0; padding-bottom: 24px">
        <div
          [reactComponent]="PatientInfoContactWrapper"
          [props]="{
            alertService: this.alertService,
            patient: patient,
            capsuleEligibilityCheckInProgress: this.capsuleEligibilityCheckInProgress,
            capsuleDeliveryAvailable: this.capsuleDeliveryAvailable
          }"
        ></div>
      </div>
      @if (membership$ | async; as membership) {
      <div class="sidebar-content bottom-border" style="margin-bottom: 0; padding-bottom: 24px">
        <div
          [reactComponent]="PatientInfoMembershipWrapper"
          [props]="{
                  alertService: this.alertService,
                  patient: patient,
                  membership: membership,
                }"
        ></div>
      </div>
      }
      <!-- Patient Note included in app-patient-info -->
      @if ((opened | async) && patient) {
      <app-patient-info [opened]="opened | async" [patient]="patient"></app-patient-info>
      } }
    </div>
  </mat-sidenav>
  }
  <mat-sidenav-content [ngClass]="{ 'sidenav-closed--content': (opened | async) === false }" id="main-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
